import { clsx } from 'clsx';
import { BRAND_SVG, type BrandMark } from './brand.data';

/**
 * Brand — the MAIE marks (symbol · type · lockup · pattern).
 *
 * Two of these carry rules rather than being decoration:
 *
 *  - `pattern` is the VOICE PATTERN. §10: "the voice pattern is the only audio
 *    visual." Recording, playback, listening states — all use this. Never draw
 *    a different waveform, a bar meter or an equaliser; it is brand art, not a
 *    render of the signal.
 *  - `symbol` is the ONLY assistant icon. The mockups' "logo on action
 *    surfaces, chat glyph on open records" rule is void.
 *
 * The marks take `currentColor`, so tint them by setting `color` — the canvas
 * layers two patterns (brand-300 under, brand-500 over) to get its depth.
 */
export function Brand({
  mark,
  className,
  style,
}: {
  mark: BrandMark;
  className?: string;
  style?: React.CSSProperties;
}) {
  // The wrapper carries the sizing, and `.kit-brand > svg` makes the SVG fill
  // it. Styling the span alone does nothing: the SVG keeps its intrinsic size
  // and a `height: 16px` wordmark renders at whatever the file says — which is
  // how the burger header ended up with no wordmark at all.
  return (
    <span
      className={clsx('kit-brand', className)}
      style={style}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: BRAND_SVG[mark] }}
    />
  );
}

export type { BrandMark };
